import WatchLive from '../features/live/layouts/watch-live';

export default function LiveWatchPage() {
    return <WatchLive />;
}
